import React, { useState, useEffect, useContext } from 'react';

import * as net from "../../../lib/net";
import Fr_Input from "../../../lib/ui/fr_input";
import Fr_Inpsel from "../../../lib/ui/fr_inpsel";
import Fak_Kund from "./fak_kund";
import Fr_Cal from "../../../lib/ui/fr_cal";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import * as utils from "../../../assets/utils";
import Wnd_Error from "../../../lib/ui/wnd_error";
import Wnd_Ok from "../../../lib/ui/wnd_ok";
import Wnd_Confirm from "../../../lib/ui/wnd_confirm";

class Fak_Pay extends React.Component {
  constructor(props, context) {
    super(props);

    this.state = {};
    this.state.mka = [];
    this.state.sval = [];
    this.state.tval = [];
    this.state.paa = [];
    this.state.uaa = [];
    this.state.laa = [];

    this.state.gnr = "001";
      this.state.ynq = [
          {id: '0', text: 'NEJ'},
          {id: '1', text: 'JA'}
      ];
      this.state.mval = [
          {val: '0000', text: 'MOMSFRITT'},
          {val: '0566', text: 'MOMS 6 %'},
          {val: '1071', text: 'MOMS 12 %'},
          {val: '2000', text: 'MOMS 25 %'}
      ];

    this.state.wnd_ok = false;
    this.state.wnd_err = false;

      this.state.msg = {};
      this.state.wnds = {};
      this.state.cols = {};
    this.state.tr00 = {};
    this.state.faknr = "";
    this.state.wfh = {};
    if(props.wnds) {
        this.state.faknr = props.wnds.faknr;
        this.state.wfh = props.wnds.wfh;
        this.state.wfh = JSON.parse(JSON.stringify(props.wnds.wfh));
        this.state.wfh.wfak00.fakdatum = this.state.wfh.wfak00.fakdatum.cdidate();
        this.state.wfh.wfak00.ffdatum = this.state.wfh.wfak00.ffdatum.cdidate();
        this.state.wfh.wfak01.levdatum = this.state.wfh.wfak01.levdatum.cdidate();
        this.state.wfh.wfak00.belopp = this.state.wfh.wfak00.belopp.cdipris();
        this.state.wfh.wfak00.moms = this.state.wfh.wfak00.moms.cdipris();
        //this.state.wfr.pris = this.state.wfr.pris.cdipris();
    }
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
    //this.btn_grps();
      //if(!this.props.wnds.wfh) this.wfh_init();
  }

    wfh_init() {
        var wfh = {};
        wfh.faktyp = "I";
        wfh.faknr = this.state.faknr;
        wfh.fakrad = "P";
        //alert(JSON.stringify(rso));
        this.setState({ wfh: wfh });
        return;
    }

    dlg_style() {
      var css = {};
      //css.width = window.innerWidth * 0.8;
      //css.height = window.innerHeight * 0.8;
      return css;
    }

    wnd_close = () => {
      if(this.props.close) {
          this.props.close(this.props.ctx);
      }
      else this.props.ctx.setState({ wnds: {} });
	};
    toggle() {
      this.setState({modal: false});
	};

  submitHandler = event => {
    event.preventDefault();
    event.target.className += " was-validated";
  };

  changeHandler = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  val_save(id, val) {
      var wfh = this.state.wfh;
      var id1 = id.split(".")[0];
      var id2 = id.split(".")[1];
      wfh[id1][id2] = val;
        this.setState({ wfh: wfh });
      return;
  }
    val_dt_save (id, dts) {
        var wfh = this.state.wfh;
        //var dts = format(value, "yyyy-MM-dd");
        //if(dts < this.state.tds) dts = this.state.tds;
        //bro.fdat = dts;
        //if(bro.tdat < dts) bro.tdat = dts;
        var id1 = id.split(".")[0];
        var id2 = id.split(".")[1];
        wfh[id1][id2] = dts;
        this.setState({ wfh: wfh });
    }
  tb_style() {
      var css = {};
      css.height = window.innerHeight - 275;
      return css;
  }
    fak_pay() {
        var self = this;

        var wfh = this.state.wfh;
        //this.state.wfh.wfak00.slutbetdat = "";
        this.state.wfh.wfak00.status = "9";

        var prm = {};
        prm.req = "fakt.fakt_fak.fak_head_save";
        prm.wfak00 = this.state.wfh.wfak00;
        prm.wfak01 = this.state.wfh.wfak01;
        prm.wfak02 = this.state.wfh.wfak02;
        prm.wfak03 = this.state.wfh.wfak03;

        net.sio_req(prm)
        .then(function(ret){
            //alert(JSON.stringify(ret));

            var wfh = JSON.parse(JSON.stringify(self.state.wfh));
            self.setState({ wfh: wfh, wnd_ok: true });

            var msg = { info: true, error: false, text: "Betald ..."};
            self.setState({msg: msg });
            setTimeout(function(){
                self.setState({wnd_ok: false });
                if(self.props.wnds.cb) {
                    self.props.wnds.cb(self.props.ctx);
                }
                else self.props.ctx.setState({ wnds: {} });
                return;
            }, 1000);
        })
        .catch(function(e){
            var txt = JSON.stringify(e);
        });
    }
    cb_kund(ctx, kro) {
        var self = this;
        var wfh = ctx.state.wfh;
        wfh.wfak00.ktyp = "K";
        wfh.wfak00.kund = kro.krr00.kid;
        wfh.wfak00.company = kro.krr00.company;
        ctx.setState({ wnds: {}, wfh: wfh });
    }
    fak_kund_sz() {
        var self = this;
        var wnds = {};
        wnds.kund = 1;
        wnds.cb = this.cb_kund;
        this.setState({ wnds: wnds });
    }

  render() {
    //if(!this.props.show) return "";
    var title = this.props.title;
    if(!title) title = "Resurs";
    //if(props.kro) alert(props.kro.krr00.kid);
    const popover = {
      position: 'absolute',
      top: '50px',
      zIndex: '2',
    }
    const cover = {
      position: 'fixed',
      top: '0px',
      right: '0px',
      bottom: '0px',
      left: '0px',
    }
    const okwnd = {
      position: 'absolute',
      width: '35%',
      height: '35%',
      zIndex: '19999',
      top: '35%',
      left: '35%',
        border: "1px solid #ccc",
        borderRadius: "5px",
       backgroundColor: "#015d00",
        backgroundImage: "linear-gradient(314deg, #015d00 0%, #04bf00 74%)"
    }
    const errwnd = {
      position: 'absolute',
      width: '35%',
      height: '35%',
      zIndex: '19999',
      top: '35%',
      left: '35%',
        border: "1px solid #ccc",
        borderRadius: "5px",
        backgroundColor: "#ED213A",  /* fallback for old browsers */
        background: "-webkit-linear-gradient(to right, #93291E, #ED213A)",  /* Chrome 10-25, Safari 5.1-6 */
        backgroundImage: "linear-gradient(to right, #93291E, #ED213A)" /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        //backgroundColor: "#8E0E00",  /* fallback for old browsers */
        //background: "-webkit-linear-gradient(to right, #1F1C18, #8E0E00)",  /* Chrome 10-25, Safari 5.1-6 */
        //backgroundImage: "linear-gradient(to right, #1F1C18, #8E0E00)" /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    }

	var html =
        <div className="mx_base">
        <div className="m2_backdrop" />
        <div className="m2_dlg mx_70 flex-col" style={ this.dlg_style() } draggable="true" >
        <div className="mx_content flex">

        <div className="mx_h01">
            <div>BETALA FAKTURA</div>
            <div>: { utils.toNum( this.state.faknr ) }</div>
        </div>
            <div className="flex-row" style={{padding:"5px",height:"35px"}}>
                    <div className="flex-col flex">
                    </div>
                    <div className="flex-col">
                        <div>UPPDATERA</div>
                    </div>
            </div>
            <div className="divider_orange"></div>

            <form className="cdi_f03">
            <div className="flex-row">
                    <Fr_Input label="Företag" className="text-left w350" text={this.state.wfh.wfak00.company} getValue={(e)=> this.val_save("wfak00.company", e) } />
                    <Fr_Input label="Orgnr" className="text-left w250" text={this.state.wfh.wfak01.orgnr} getValue={(e)=> this.val_save("wfak01.orgnr", e) } />
            </div>
            <div className="divider_green"></div>
                <div className="flex-row">
                    <Fr_Cal label="Fak Datum" className="text-left w250" min="0" text={this.state.wfh.wfak00.fakdatum} getValue={(e)=> this.val_dt_save( "wfak00.fakdatum", e ) }/>
                    <Fr_Cal label="FF Datum" className="text-left w250" min="0" text={this.state.wfh.wfak00.ffdatum} getValue={(e)=> this.val_dt_save( "wfak00.ffdatum", e ) }/>
                </div>
                <div className="flex-row">
                    <Fr_Cal label="Lev Datum" className="text-left w250" min="0" text={this.state.wfh.wfak01.levdatum} getValue={(e)=> this.val_dt_save( "wfak01.levdatum", e ) }/>
                </div>
                <div className="flex-row">
                    <Fr_Input label="Belopp" className="text-left w250" text={this.state.wfh.wfak00.belopp} getValue={(e)=> this.val_save("wfak00.belopp", e) } />
                    <Fr_Input label="Moms" className="text-left w250" text={this.state.wfh.wfak00.moms} getValue={(e)=> this.val_save("wfak00.moms", e) } />
                </div>
                <div className="flex-row">
                    <Fr_Cal label="Betal Datum" className="text-left w250" min="0" text={this.state.wfh.wfak00.slutbetdat} getValue={(e)=> this.val_dt_save( "wfak00.slutbetdat", e ) }/>
                </div>

            </form>

        </div>
        <div className="mx_foot flex-row flex-space-between">
            <button className="btn btn-hw-red w250" onClick={() => this.wnd_close() } >
                STÄNG
            </button>
            <div className="flex"></div>
            <div className="flex"></div>
            <button className="btn btn-hw-red w250" onClick={() => this.fak_pay() } >
                BETALA
            </button>
        </div>
      </div>

            <Wnd_Error msg={this.state.msg} ctx={this} />
            <Wnd_Ok msg={this.state.msg} ctx={this} />
            <Wnd_Confirm msg={this.state.msg} ctx={this} />
            { this.state.wnds.kund ? <Fak_Kund wnds={this.state.wnds} ctx={this} backdrop={true}/> : null }
      </div>
	;
	return html;
  };
}

export default Fak_Pay;